import React, { useEffect } from 'react';
import { Layout, Button, Tag, Space, Typography } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/auth';
import Board from './Board';
import { Navigate } from 'react-router-dom';
import { SALES_REP_HOME_PATH, isSalesRep } from '../modules/salesRep/salesRepAccessPolicy';

const { Header, Content } = Layout;
const { Text } = Typography;

const ROLE_COLORS: Record<string, string> = {
  ADMIN: 'red',
  OPERATIONS: 'blue',
  ORDER_STAFF: 'green',
  PARTNER: 'purple',
  TESTER: 'orange',
};

const BoardStandalone: React.FC = () => {
  const { t, i18n } = useTranslation('board');
  const user = authService.getCurrentUser();

  useEffect(() => {
    i18n.changeLanguage('pl');
  }, [i18n]);

  const handleLogout = () => {
    authService.logout();
  };

  // The board is outside the Handlowiec scope (backend returns 403).
  if (isSalesRep(user)) {
    return <Navigate to={SALES_REP_HOME_PATH} replace />;
  }

  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <Header
        style={{
          background: '#ffffff',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: '1px solid #e8e8e8',
          height: 56,
          lineHeight: '56px',
        }}
      >
        <Text strong style={{ fontSize: 16 }}>
          Azzura
        </Text>
        <Space>
          {user && (
            <>
              <Text style={{ color: '#595959' }}>{user.name}</Text>
              <Tag color={ROLE_COLORS[user.role] ?? 'default'}>{user.role}</Tag>
            </>
          )}
          <Button
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            size="small"
          >
            {t('standalone.logout')}
          </Button>
        </Space>
      </Header>
      <Content style={{ padding: 24 }}>
        <Board />
      </Content>
    </Layout>
  );
};

export default BoardStandalone;
